export default "__VITE_ASSET__HheaYHnT__"